import React from 'react';

const OdaRatesTableComponentLoadable = React.lazy(() => import('./OdaRatesTableComponent'));

export {
    OdaRatesTableComponentLoadable
};